import React from 'react'
import View from './view.js'
import useIsHovered from 'Logic/useIsHovered.js'

export default function Logic(props) {
  let [isHoveredManual, , hoverBind] = useIsHovered({
    isDisabled: false,
    isSelected: false,
  })

  return (
    <View
      isHoveredManual={isHoveredManual}
      onMouseEnter={hoverBind.onMouseEnter}
      onMouseLeave={hoverBind.onMouseLeave}
      {...props}
    />
  )
}
